import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { auth, firestore } from '../../config/firebase';
import { signIn } from '../../store/actions/authActions';
import { fetchUser } from '../../store/actions/userActions';
import Spinner from '../UIComponents/Spinner';

class SignUp extends Component {
    state = { email: '', password: '', msg: '', display: 'none' }

    changeInputHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    submitFormHandler = (e) => {
        e.preventDefault();
        const { email, password } = this.state;
        this.setState({ display: 'flex' })
        // Sign In method
        auth.createUserWithEmailAndPassword(email, password)
            .then(async (response) => {
                const { email, uid, displayName } = response.user;
                console.log(uid, response.user);

                await this.props.signIn({ uid, email, isLogged: true, isAdmin: true, userType: 'admin', displayName });

                // Check if the user with the id exist
                const currentUser = firestore.collection('users').doc(uid);
                currentUser.get().then(async (doc) => {
                    if (!doc.exists) {
                        await currentUser.set({ email, uid, password, id: uid });
                        await this.props.fetchUser({ id: uid, uid, password, email });
                        this.props.history.push('/profile');
                    } else {
                        this.props.history.push('/');
                    }

                    this.setState({ display: 'none' })
                })

                // if(this.props.location.pathname !== '/') {
                //     this.props.history.push('/');
                // }
            })
            .catch(err => this.setState({ msg: err.message, display: 'none' }))
    }

    render() {
        console.log(this.state)
        return (
            <div className="container d-flex h-100 my-5 py-5 flex-column text-center align-items-center justify-content-center">
                {this.state.msg ? <div className="alert alert-danger">{this.state.msg}</div> : null}
                <Spinner display={this.state.display} />
                <h3 className="mt-5">Sign Up</h3>
                <form className="w-50" onSubmit={(event) => this.submitFormHandler(event)}>
                    <div className="form-group text-left">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            placeholder="Enter email"
                            name="email"
                            onChange={(event) => this.changeInputHandler(event)}
                        />
                    </div>
                    <div className="form-group text-left">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="Password"
                            name="password"
                            onChange={(event) => this.changeInputHandler(event)}
                        />
                    </div>
                    <div className="text-left my-4">
                        <i>If you have an account already </i><Link to="sign-in">Sign In</Link> please!
                    </div>
                    <button type="submit" className="btn btn-primary px-5">Sing Up</button>
                </form>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        signIn: (uid, email, isLogged, isAdmin, displayName) => dispatch(signIn(uid, email, isLogged, isAdmin, displayName)),
        fetchUser: (data) => dispatch(fetchUser(data)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignUp));